import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedFormsModule, SharedModule } from '@shared/shared.module';
import { SwiperModule } from 'swiper/angular';
import { ChangeTitleComponent } from './change-title/change-title.component';
import { CompleteFormComponent } from './complete-form/complete-form.component';
import { DialogComponent } from './dialog/dialog.component';
import { FinancialHealthComponentsModule } from './financial-health/components/financial-health-components.module';
import { FinancialHealthComponent } from './financial-health/financial-health.component';
import { FinancialInfoComponentsModule } from './financial-info/components/financial-info-components.module';
import { FinancialInfoComponent } from './financial-info/financial-info.component';
import { InsuranceReasonsComponent } from './insurance-reasons/insurance-reasons.component';
import { PrivacityComponent } from './privacity/privacity.component';
import { ProductSelectComponentsModule } from './product-select/components/product-select-components.module';
import { ProductSelectComponent } from './product-select/product-select.component';
import { ProductComponent } from './product/product.component';
import { SavingGoalsComponent } from './saving-goals/saving-goals.component';
import { ShareComponent } from './share/share.component';
import { ToastComponent } from './toast/toast.component';
import { UniversityComponent } from './university/university.component';

const MODALS_DECLARATIONS = [
  ChangeTitleComponent,
  CompleteFormComponent,
  DialogComponent,
  FinancialHealthComponent,
  FinancialInfoComponent,
  InsuranceReasonsComponent,
  PrivacityComponent,
  ProductComponent,
  ProductSelectComponent,
  SavingGoalsComponent,
  ShareComponent,
  ToastComponent,
  UniversityComponent
];

@NgModule({
  declarations: MODALS_DECLARATIONS,
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ClipboardModule,
    OverlayModule,
    SharedFormsModule,
    ReactiveFormsModule,
    FinancialHealthComponentsModule,
    FinancialInfoComponentsModule,
    ProductSelectComponentsModule,
    SwiperModule,
    TranslateModule
  ],
  exports: MODALS_DECLARATIONS
})
export class ModalsModule {}
